import { FormlyFieldConfig } from '@ngx-formly/core';

import {
  ISnRadioTemplateOptions,
  ISnRadioGroupTemplateOptions,
} from './radio-template-options.interface';

export interface ISnRadioFormFieldConfig<O = any> extends FormlyFieldConfig {
  type: 'radio';
  templateOptions: ISnRadioTemplateOptions<O> | ISnRadioGroupTemplateOptions<O>;
}
